import unlockProgramField from "./unlock-program-field";
import netRequests from "./netRequests";
import datepicker from "./datepicker";
import form from "./form";
import select from "./select";
import catalog from "../catalog";
import initDropDownsPrograms from "./dropDownPrograms";

const initForm = () => {
  async function initNetRequests() {
    const allPrograms = await netRequests();

    // Возвращаем только офлайн программы
    // MARKDEV-530 Костылище номер 1. Исключить из формы заявки 4 программы
    const OFFLINE_PROGRAMS = allPrograms.programs.filter(
      (program) => program.educational_form == "offline" && (program.name !== "Сварщик ручной дуговой сварки плавящимся покрытым электродом" && program.name !== "Оператор станков с ЧПУ" && program.name !== "Младшая медицинская сестра по уходу за больными" && program.name !== "Основы агрономии" && program.name !== "Электромонтажник по силовым сетям и электрооборудованию")
    );

    // Инициализация
    initRegions(offlineRegions(OFFLINE_PROGRAMS, allPrograms.regions));
    initDropDownsPrograms(OFFLINE_PROGRAMS, allPrograms.cities);

    /* Разблокирование поля "Программы обучения" после получения списка программ */
    unlockProgramField();

    /* Логика для короткой формы short-form */
    // shortForm(allPrograms);

    catalog(OFFLINE_PROGRAMS);
  }

  datepicker();
  select();
  initNetRequests();
  form();

  /* Доступные регионы для офйлан программ */
  function offlineRegions(programs, regions) {
    let allListRegions = [];

    for (let program of programs) {
      for (let region of program.regions) {
        allListRegions.push(region.region_id);
      }
    }

    let dublicateListRegions = allListRegions.filter((item, index) => {
      return allListRegions.indexOf(item) === index;
    });

    return regions.filter((e) => dublicateListRegions.includes(e.id));    
  }

  /* Добавление регионов в форму */
  function initRegions(data) {
    try {
      function addRegionsSelect(id) {
        let regionsSelect = $(id);

        data.forEach(function (el) {
          let selected = false,
            option = new Option(el.name, el.id, false, selected);

          option.accessKey = el.id;
          regionsSelect.append(option);
        });

        regionsSelect.val(null);
        regionsSelect.select2({
          placeholder: "Ваш регион",
        });
      }

      addRegionsSelect("#Regions");
      addRegionsSelect("#CatalogRegions");
    } catch (e) {
      console.log(e);
    }
  }
};

export default initForm;
